export * from './base-contentful.service';
